import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useCurrentWorkspace } from "../../Query/useWorkspace";

interface TokenConsumerProviderProps {
  children: React.ReactNode;
}

const TokenConsumerProvider: React.FC<TokenConsumerProviderProps> = ({
  children,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { i18n } = useTranslation();
  const { data: workspace } = useCurrentWorkspace();

  useEffect(() => {
    const token = searchParams.get("cih-token");

    if (token) {
      localStorage.setItem("cih_token", token);

      setSearchParams(
        (prev) => {
          prev.delete("cih-token");
          return prev;
        },
        { replace: true }
      );
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (!workspace?.workspace) return;

    const storedLang = localStorage.getItem("i18nextLng");

    if (storedLang) {
      if (i18n.language !== storedLang) {
        i18n.changeLanguage(storedLang);
      }
      return;
    }
    if (workspace?.workspace?.language !== undefined) {
      const workspaceLang = workspace.workspace.language === 0 ? "en" : "de";
      if (i18n.language !== workspaceLang) {
        i18n.changeLanguage(workspaceLang);
        localStorage.setItem("i18nextLng", workspaceLang);
      }
    }
  }, [workspace, i18n]);

  return <>{children}</>;
};

export default TokenConsumerProvider;
